<div class="card-header">
  <span [ngSwitch]="listing">
    <span *ngSwitchCase="false">Add/Update Admin User</span>
    <span *ngSwitchCase="true">Existing Admin Users</span>
  </span>
  <button class="btn btn-sm btn-warning float-right"
    style="margin-top: -4px;font-size: 14px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;"
    (click)="toggleView()">
    <span *ngIf="listing" tooltip="Click here to add new admin user">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Admin User</span>
    <span *ngIf="!listing">
      <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
  </button>
</div>

<div class="content-body padding-top-20 padding-bottom-20">
  <div class="row">
    <div *ngIf="listing; then tableTemplate; else userFormTemplate;">
    </div>
    <ng-template #tableTemplate>

      <p-table [value]="users" [lazy]="true" (onLazyLoad)="onPageChange($event)"
        [paginator]="users != null && users.length > 0" [rows]="rows" [first]="paging.currentPage"
        [totalRecords]="totalRecords" #dt>
        <ng-template pTemplate="header">
          <tr style="height:60px;">
            <th style="width:100px;text-align: center;">#
            </th>
            <th>User Name
            </th>
            <th>Email
            </th>
            <th>Mobile
            </th>
            <th>Role
            </th>
            <th>Belongs to
            </th>
          </tr>

          <tr style="font-family:Arial, FontAwesome;text-align: center;">
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  User name " pInputText
                type="text" (input)="onSearch($event.target.value,'name')">
              <!-- <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  User name " pInputText type="text"
                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  E-mail" pInputText
                type="text" (input)="onSearch($event.target.value,'email')">
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Mobile number" pInputText
                type="text" (input)="onSearch($event.target.value,'mobile')">
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Account Name" pInputText
                type="text" (input)="onSearch($event.target.value,'accountname')">
            </td>
          </tr>
          <tr *ngIf="users==null || users.length==0"
            style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
            <td colspan="6">
              <div style="padding: 5px;text-align: center;">
                No record found
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-i="rowIndex">
          <tr class="table-striped" style="cursor: pointer;" (click)="editUserInfo(user)">
            <td style="text-align: center;padding-bottom: 25px;padding-top:25px;">{{i+1}}</td>
            <td>{{user.firstName}} {{user.lastName}}</td>
            <td>{{user.email}}</td>
            <td>{{user.phoneNo}}</td>
            <td>{{getUserRoleName(user.roleName)}}</td>
            <td>
              <span *ngIf="user.accountId!=null && user.roleName.indexOf('ROLE_OPERATIONAL_ADMIN')<0">
                {{user.accountName}}
              </span>
              <span *ngIf="user.providerId!=null && user.roleName.indexOf('ROLE_OPERATIONAL_ADMIN')<0">
                {{providerNameValidation(user.providerName)}}
              </span>
              <span *ngIf="user.roleName.indexOf('ROLE_OPERATIONAL_ADMIN')>-1">
                {{providerNameValidation(user.providerName)}}
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>
    <ng-template #userFormTemplate>
      <form #userinfoForm="ngForm" class="mTop30" novalidate (ngSubmit)="addupdateUser()">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class=" form-group">
            <label class="form-label">User Role
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">User Role</span>
            <span class="desc " *ngIf="!operationalAdminSelectionValidation" style="color: red;">{{warningMessage}}</span>
            <div class="controls">
              <!--<angular2-multiselect class="form-control" (onSelect)="rolesModified($event,null)"
                (onDeSelect)="rolesModified($event,null)" (onSelectAll)="rolesModified($event,'selectedAll')"
                (onDeSelectAll)="rolesModified($event,'deselectedAll')" [settings]="{ enableSearchFilter: true}"
                [data]="availableUserRoles" name="userRoles" #userRoles="ngModel" [(ngModel)]="adminUserRoles">
              </angular2-multiselect>-->
              <ng-multiselect-dropdown [settings]="dropdownSettings" (onSelect)="rolesModified($event,null)"
                (onDeSelect)="rolesModified($event,null)" (onSelectAll)="rolesModified($event,'selectedAll')"
                (onDeSelectAll)="rolesModified($event,'deselectedAll')" [data]="availableUserRoles" name="userRoles"
                #userRoles="ngModel" [(ngModel)]="adminUserRoles">
              </ng-multiselect-dropdown>
              <!-- <select *ngIf="userInfo.userId==null" class="form-select form-select-sm" (change)="updateBelongsTo(userInfo.roleName)" [(ngModel)]="userInfo.roleName"
                      #roleName="ngModel" name="roleName" id="roleName">
                      <option value="ROLE_OPTHALMOLOGY_SUPERVISOR">Screening Center Manager</option>
                      <option value="ROLE_PROGRAM_LEAD">Account Admin</option>
                      <option value="ROLE_SPECTACLE_ADMIN">Spectacle Admin</option>
                    </select> -->
              <!-- <span *ngIf="userInfo.userId!=null" style="font-weight: bold;font-style: italic;">{{getUserRoleName(userInfo.roleName)}}</span> -->
            </div>
          </div>
        </div>
        <div
          [ngClass]="{'col-xs-12 col-sm-12 col-md-12 col-lg-12':!isUserBelongsToProvider,'col-xs-12 col-sm-12 col-md-6 col-lg-6':isUserBelongsToProvider}"
          *ngIf="isUserBelongsToAccount">
          <div class=" form-group">
            <label class="form-label" for="field-1">Belongs to Account</label>
            <span class="desc">User belongs to Account</span>
            <div class="controls">
              <!-- <select [(ngModel)]="userInfo.accountId" class="form-select form-select-sm" #belongsToAccount="ngModel"
                id="belongsToAccount" name="belongsToAccount" *ngIf="!showMultiSelect">
                <option value=null>Select Account</option>
                <option *ngFor="let account of accounts" [ngValue]="account.accountId">{{account.accountName}}</option>
              </select> -->

              <ng-select *ngIf="!showMultiSelect" [items]="accounts" name="accounts" bindLabel="accountName"
                [(ngModel)]="userInfo.accountId" [clearable]="true" [searchable]="true" bindValue="accountId"
                placeholder="Select account">
              </ng-select>

              <ng-multiselect-dropdown *ngIf="showMultiSelect" [settings]="dropdownSettings" [data]="accountsList"
                id="belongsToAccount" name="belongsToAccount" #belongsToAccount="ngModel"
                [(ngModel)]="userInfo.accountId">
              </ng-multiselect-dropdown>
              <!-- <span *ngIf="userInfo.userId!=null && userInfo.accountId!=null" style="font-weight: bold;font-style: italic;">{{getAccountName(userInfo.accountId)}}</span> -->
            </div>
          </div>
        </div>
        <div
          [ngClass]="{'col-xs-12 col-sm-12 col-md-12 col-lg-12':!isUserBelongsToAccount,'col-xs-12 col-sm-12 col-md-6 col-lg-6':isUserBelongsToAccount}"
          *ngIf="isUserBelongsToProvider">
          <div class=" form-group">
            <label class="form-label" for="field-1">Belongs to Service Provider</label>
            <span class="desc">User belongs to spectacle provider</span>
            <div class="controls">
              <!-- <select *ngIf="!showMultiSelect" class="form-select form-select-sm" [(ngModel)]="userInfo.providerId" #belongsToReviewTeam="ngModel"
              name="belongsToReviewTeam" id="belongsToReviewTeam">
              <option value=null>Select Service Provider</option> -->
              <!-- <option value="null">Select Spectacle Vendor</option> -->
              <!-- <option *ngFor="let provider of serviceProvidersDropdown |  orderBy: 'type' : 'providerName' "
                [ngValue]="provider.providerId">{{provider.providerName}}</option>
            </select> -->

              <ng-select *ngIf="!showMultiSelect" class="form-control" [items]="serviceProvidersDropdown"
                name="serviceProviders" bindLabel="providerName" [(ngModel)]="userInfo.providerId" [clearable]="true"
                [searchable]="true" bindValue="providerId" placeholder="Select account">
              </ng-select>

              <!--<angular2-multiselect *ngIf="showMultiSelect" class="form-control" [settings]="{ enableSearchFilter: true}"
                [data]="providersList" id="belongsToReviewTeam" name="belongsToReviewTeam" #belongsToReviewTeam="ngModel" [(ngModel)]="userInfo.providerId">
              </angular2-multiselect>-->
              <ng-multiselect-dropdown  *ngIf="showMultiSelect" [settings]="dropdownSettings"
                [data]="providersList" id="belongsToReviewTeam" name="belongsToReviewTeam" #belongsToReviewTeam="ngModel" [(ngModel)]="userInfo.providerId">
              </ng-multiselect-dropdown >
              <!-- <span *ngIf="userInfo.userId!=null && userInfo.providerId!=null" style="font-weight: bold;font-style: italic;">{{getProviderName(userInfo.providerId)}}</span> -->
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">Title
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Salutation</span>
            <div class="controls">
              <select [(ngModel)]="userInfo.title" class="form-select form-select-sm" #userTitle="ngModel" id="userTitle"
                name="userTitle">
                <option value="Dr.">Dr.</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Miss.">Miss.</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">Gender
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Sex/Gender</span>
            <div class="controls">
              <select [(ngModel)]="userInfo.gender" class="form-select form-select-sm" #userGender="ngModel" id="userGender"
                name="userGender">
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
          <div class=" form-group">
            <label class="form-label" for="field-1">First Name
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">First Name</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.firstName" #firstName="ngModel" name="firstName" id="firstName"
                pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter first name here..." required />
              <!-- <div [hidden]="firstName.valid || firstName.pristine" class="danger-text">
                First name is required
              </div> -->
              <div *ngIf="firstName.errors && firstName.dirty" class="danger-text">
                <div *ngIf="firstName.errors.required">
                  First Name is required
                </div>
                <div *ngIf="firstName.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">Last Name</label>
            <span class="desc">Last Name/Surname</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.lastName" #lastName="ngModel" name="lastName" id="lastName"
                pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter last name here..." />
              <!-- <div [hidden]="lastName.valid || lastName.pristine" class="danger-text">
                Last name is required
              </div> -->
              <div *ngIf="lastName.errors && lastName.dirty" class="danger-text">
                <div *ngIf="lastName.errors.required">
                  Last Name is required
                </div>
                <div *ngIf="lastName.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
          <div class=" form-group">
            <label class="form-label" for="field-1">Email
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Email id for login & communication to admin user</span>
            <div class="controls">
              <input autocomplete="off" type="email" (keyup)="validateUserEmailExists(admininfoForm)" name="userEmail"
                id="userEmail" pattern="[a-zA-Z0-9_.+\-]{1,}@[a-zA-Z.-]{2,}\.[a-zA-Z]{2,}" #userEmail="ngModel"
                [(ngModel)]="userInfo.email" class="form-control" placeholder="Enter email address here..." required />
              <div *ngIf="userEmail.errors && userEmail.dirty" class="danger-text">
                <div *ngIf="userEmail.errors.required">
                  Email is required
                </div>
                <div *ngIf="userEmail.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
              <div *ngIf="userEmailExists" class="danger-text">
                User email already exits
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">Mobile
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Mobile number to communicate the admin user</span>
            <div class="controls">
              <input type="text" (keyup)="validateUserMobileExists()" (keypress)="_keyPress($event)"
                [(ngModel)]="userInfo.phoneNo" required pattern="^[0-9]{6,}$" #userMobile="ngModel" name="userMobile"
                id="userMobile" class="form-control" placeholder="Enter mobile number here..." minlength="6" />
              <div *ngIf="userMobile.errors?.required && !userMobile.pristine" class="danger-text">
                Mobile number is required
              </div>
              <div *ngIf="userMobile.errors?.pattern && !userMobile.pristine" class="danger-text">
                Invalid mobile number! Must be at least 6 digits.
              </div>
              <div *ngIf="userMobileExists && userMobile.valid" class="danger-text">
                User mobile already exists
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both" *ngIf="userInfo.userId==null">
          <div class=" form-group">
            <label class="form-label" for="field-1">Password
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Temporary password to be given to account admin</span>
            <div class="controls">
              <input class="form-control" [(ngModel)]="userInfo.password" #password="ngModel" required id="password"
                name="password" type="password" placeholder="Enter password here..."
                (keyup)="isStrongPassword = checkStrongPassword(userInfo.password)">
              <!-- start : strong password check-->
              <div>
                <span *ngIf="userInfo.password && userInfo.password.length>0 && isStrongPassword"
                  style="background-color:#27c24c;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                    class="fa fa-check-circle">&nbsp;</i>Strong Password</span>
                <span *ngIf="userInfo.password && userInfo.password.length>0 && !isStrongPassword"
                  style="background-color:#f05050;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                    class="fa fa-times-circle">&nbsp;</i>Weak Password</span>
                <span class="pull-right"><a (click)="showPasswordPolicy = !showPasswordPolicy"
                    style="cursor: pointer;"><span *ngIf="!showPasswordPolicy">Show</span><span
                      *ngIf="showPasswordPolicy">Hide</span> password policy</a></span>
              </div>
              <div *ngIf="showPasswordPolicy">
                <span style="font-style: italic;">
                  Password must contain
                  <ol>
                    <li>Minimum 8 letters</li>
                    <li>At least 1 uppercase character</li>
                    <li>At least 1 lowercase character</li>
                    <li>At least 1 number</li>
                    <li>At least 1 special character</li>
                  </ol>
                </span>
              </div>
              <!-- end : strong password check-->
              <div [hidden]="password.valid || password.pristine" class="danger-text">
                Password is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="userInfo.userId==null">
          <div class=" form-group">
            <label class="form-label" for="field-1">Confirm Password
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Repeat the password entered</span>
            <div class="controls">
              <input class="form-control" [(ngModel)]="confirmPassword" #confirmPasswordText="ngModel" required
                id="confirmPassword" type="password" name="confirmPassword"
                placeholder="Enter confirm password here...">
              <div [hidden]="confirmPasswordText.valid || confirmPasswordText.pristine" class="danger-text">
                Confirm Password is required
              </div>
              <div *ngIf="userInfo.password !=confirmPassword && confirmPasswordText.dirty" class="danger-text">
                Password and confirm password should match
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
          <div class=" form-group">
            <label class="form-label" for="field-1">Address Line1
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Flat/Door/Block No</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.addressLine1" #addressLine1="ngModel" name="addressLine1"
                pattern=".*[a-zA-Z0-9].*" id="userAddressLine1" class="form-control"
                placeholder="Enter address line1 here..." required />
              <!-- <div [hidden]="addressLine1.valid || addressLine1.pristine" class="danger-text">
                Address Line1 is required
              </div> -->
              <div *ngIf="addressLine1.errors && addressLine1.dirty" class="danger-text">
                <div *ngIf="addressLine1.errors.required">
                  Address Line1 is required
                </div>
                <div *ngIf="addressLine1.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">AddressLine 2
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Area/Locality</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.addressLine2" #addressLine2="ngModel" name="addressLine2"
                pattern=".*[a-zA-Z0-9].*" id="useAaddressLine2" class="form-control"
                placeholder="Enter address line2 here..." required />
              <!-- <div [hidden]="addressLine2.valid || addressLine2.pristine" class="danger-text">
                Address Line2 is required
              </div> -->
              <div *ngIf="addressLine2.errors && addressLine2.dirty" class="danger-text">
                <div *ngIf="addressLine2.errors.required">
                  Address Line2 is required
                </div>
                <div *ngIf="addressLine2.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
          <div class=" form-group">
            <label class="form-label" for="field-1">District
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">District/City/Town</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.district" #district="ngModel" name="district"
                pattern=".*[a-zA-Z].*" id="userDistrict" class="form-control" placeholder="Enter district here..."
                required />
              <!-- <div [hidden]="district.valid || district.pristine" class="danger-text">
                District is required
              </div> -->
              <div *ngIf="district.errors && district.dirty" class="danger-text">
                <div *ngIf="district.errors.required">
                  District is required
                </div>
                <div *ngIf="district.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">State
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">State</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.state" #state="ngModel" name="state" id="userState"
                pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter state here..." required />
              <!-- <div [hidden]="state.valid || state.pristine" class="danger-text">
                State is required
              </div> -->
              <div *ngIf="state.errors && state.dirty" class="danger-text">
                <div *ngIf="state.errors.required">
                  State is required
                </div>
                <div *ngIf="state.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
          <div class=" form-group">
            <label class="form-label" for="field-1">Pincode
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Pincode</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.zipcode" #pincode="ngModel" name="pincode"
                pattern="^[0-9 ]*" id="userPincode" class="form-control" placeholder="Enter pincode here..." required />
              <!-- <div [hidden]="pincode.valid || pincode.pristine" class="danger-text">
                Pincode is required
              </div> -->
              <div *ngIf="pincode.errors && pincode.dirty" class="danger-text">
                <div *ngIf="pincode.errors.required">
                  Pincode is required
                </div>
                <div *ngIf="pincode.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class=" form-group">
            <label class="form-label" for="field-1">Country
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc">Country</span>
            <div class="controls">
              <input type="text" [(ngModel)]="userInfo.address.country" #country="ngModel" name="country"
                pattern="^[a-zA-Z ]*" id="userCountry" class="form-control" placeholder="Enter country here..."
                required />
              <!-- <div [hidden]="country.valid || country.pristine" class="danger-text">
                Country name is required
              </div> -->
              <div *ngIf="country.errors && country.dirty" class="danger-text">
                <div *ngIf="country.errors.required">
                  Country is required
                </div>
                <div *ngIf="country.errors.pattern">
                  Invalid input, please check and enter correct details.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="showMultiSelect">
          <div class=" form-group">
            <label class="form-label">Enable 2-Step Authentication</label>
            <span class="desc"></span>
            <div class="controls">
              <div class="chiller_cb">
                <input id="isLoginOTPRequired" [(ngModel)]="userInfo.isLoginOTPRequired" name="isLoginOTPRequired"
                  type="checkbox" />
                <label style="font-weight: normal;" for="isLoginOTPRequired">OTP Based Authentication</label>
                <span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 " *ngIf="userInfo.accountId!=null && userInfo.accountId>0">
          <div class=" form-group">
            <label class="form-label">Payment Feature</label>
            <span class="desc">Select to allow payments for this user</span>
            <div class="controls">
              <div class="chiller_cb">
                <input id="canDoPayment" [(ngModel)]="userInfo.canDoPayment" name="canDoPayment" type="checkbox" />
                <label style="font-weight: normal;" for="canDoPayment">Allow payments</label>
                <span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="showMultiSelect">
          <div class=" form-group">
            <label class="form-label">Date Format
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="desc"></span>
            <div class="controls">
              <select [(ngModel)]="userInfo.dateFormat" required class="form-select form-select-sm" #timezone="ngModel"
                id="dateformat" name="dateformat">
                <option *ngFor="let format of dateFormatList" [ngValue]="format">{{format}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="col-xs-12 text-center mTop15">
            <button [disabled]="!userinfoForm.form.valid" style="margin-right: 5px;" type="submit" class="btn
                      btn-sm btn-success marginLR5">
              <i class="fa fa-fw fa-lg fa-check-circle"></i>
              Save User</button>
            <button (click)="toggleView()" style="margin-left: 5px;" class="btn btn-sm btn-danger marginLR5">
              <i class="fa fa-fw fa-lg fa-times-circle"></i>
              Cancel</button>
          </div>
        </div>
      </form>
    </ng-template>
  </div>
</div>